import React, { useState, useMemo } from 'react';
import { useIntl } from 'react-intl';
import SectionTextMaybe from '../SectionTextMaybe';
import { IconArrowHead } from '../../../components';

import css from './AdditionalInfo.module.css';

const infoConfig = [
  { key: 'cruisingSpeed', unit: 'knopen' },
  { key: 'maxSpeed', unit: 'knopen' },
  { key: 'displacement', unit: 'ton' },
  { key: 'draughtKeelup', unit: 'meter' },
  { key: 'freshWater', unit: 'meter' },
  { key: 'headroom', unit: 'liter' },
];

const AdditionalInfo = ({ listingInfo = {} }) => {
  const intl = useIntl();
  const [expanded, setExpanded] = useState(false);

  const items = useMemo(() => {
    const mapped = infoConfig.map(item => {
      const value = listingInfo[item.key];
      return value === undefined || value === null
        ? null
        : {
            ...item,
            value,
            label: intl.formatMessage({
              id: `ListingPage.additionalInfo.${item.key}`,
            }),
          };
    });

    return mapped.filter(Boolean);
  }, [listingInfo, intl]);

  const allUndefined = infoConfig.every(
    item => listingInfo[item.key] === undefined || listingInfo[item.key] === null
  );

  if (allUndefined) return null;

  return (
    <div className={css.wrapper}>
      {!expanded ? (
        <button className={css.showMore} onClick={() => setExpanded(true)}>
          {intl.formatMessage({ id: 'General.showMore' })}{' '}
          <IconArrowHead direction="down" className={css.arrowIcon} />
        </button>
      ) : (
        <div className={css.items}>
          {items.map(item => (
            <div key={item.key} className={css.item}>
              <SectionTextMaybe text={`${item.value} ${item.unit}`} heading={item.label} />
            </div>
          ))}
        </div>
      )}
      {expanded && (
        <button className={css.showMore} onClick={() => setExpanded(false)}>
          {intl.formatMessage({ id: 'Global.showLess' })}{' '}
          <IconArrowHead direction="up" className={css.arrowIcon} />
        </button>
      )}
    </div>
  );
};

export default AdditionalInfo;
